import React from 'react';
import { Header, Footer, Form } from '../components/common';
import { useContactForm } from '../utils/contactForm';
import '../components/common/PageLayout.css';
import './Contact.css';

const Contact = () => {
  const { submitStatus, handleSubmit, errorMessage } = useContactForm(
    'Something went wrong. Please try again or email us directly.'
  );

  return (
    <>
      <div className="hero-gradient-wrap">
        <Header ctaText="Join Community" ctaPath="#courses" />
        <section className="page-hero">
          <h1>Contact Us</h1>
          <p>Get in touch for partnerships, support, or general inquiries. We’ll respond as soon as we can.</p>
        </section>
      </div>
      <main className="page-layout-main">
        <section className="page-section">
          <Form
            title="Get in Touch"
            subtitle="We'd love to answer your queries. Send us a message and we'll respond as soon as we can."
            onSubmit={handleSubmit}
            submitStatus={submitStatus}
            errorMessage={errorMessage}
          />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Contact;
